exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pointer[_v-566e225b]{cursor:pointer}.click-table[_v-566e225b]{background-color:#f9ebeb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-566e225b&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/offers/offers-clients-info.vue
// module id = 359
// module chunks = 0